/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CustomerModuleList,
  CustomerModuleView,
  ErrorResponse,
  SetCustomerModuleBody,
} from '../models/index';
import {
    CustomerModuleListFromJSON,
    CustomerModuleListToJSON,
    CustomerModuleViewFromJSON,
    CustomerModuleViewToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    SetCustomerModuleBodyFromJSON,
    SetCustomerModuleBodyToJSON,
} from '../models/index';

export interface ListCustomerModulesRequest {
    customerId: string;
    xRequestID?: string;
}

export interface SetCustomerModuleRequest {
    customerId: string;
    moduleId: string;
    setCustomerModuleBody: SetCustomerModuleBody;
    xRequestID?: string;
}

/**
 * 
 */
export class CustomerModulesApi extends runtime.BaseAPI {

    /**
     * List every module in the catalog with the active customer\'s enable + feature state.
     */
    async listCustomerModulesRaw(requestParameters: ListCustomerModulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerModuleList>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling listCustomerModules().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["read:customer-modules"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/customer-modules`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerModuleListFromJSON(jsonValue));
    }

    /**
     * List every module in the catalog with the active customer\'s enable + feature state.
     */
    async listCustomerModules(requestParameters: ListCustomerModulesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerModuleList> {
        const response = await this.listCustomerModulesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enable or disable a module for the active customer, or change its enabled features. `enabled: false` removes the module; `enabled: true` inserts it (or reconciles its features when already enabled). Features must be a subset of the module\'s offered features.
     */
    async setCustomerModuleRaw(requestParameters: SetCustomerModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerModuleView>> {
        if (requestParameters['customerId'] == null) {
            throw new runtime.RequiredError(
                'customerId',
                'Required parameter "customerId" was null or undefined when calling setCustomerModule().'
            );
        }

        if (requestParameters['moduleId'] == null) {
            throw new runtime.RequiredError(
                'moduleId',
                'Required parameter "moduleId" was null or undefined when calling setCustomerModule().'
            );
        }

        if (requestParameters['setCustomerModuleBody'] == null) {
            throw new runtime.RequiredError(
                'setCustomerModuleBody',
                'Required parameter "setCustomerModuleBody" was null or undefined when calling setCustomerModule().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xRequestID'] != null) {
            headerParameters['X-Request-ID'] = String(requestParameters['xRequestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", ["write:customer-modules"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/{customerId}/customer-modules/{moduleId}`;
        urlPath = urlPath.replace(`{${"customerId"}}`, encodeURIComponent(String(requestParameters['customerId'])));
        urlPath = urlPath.replace(`{${"moduleId"}}`, encodeURIComponent(String(requestParameters['moduleId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetCustomerModuleBodyToJSON(requestParameters['setCustomerModuleBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerModuleViewFromJSON(jsonValue));
    }

    /**
     * Enable or disable a module for the active customer, or change its enabled features. `enabled: false` removes the module; `enabled: true` inserts it (or reconciles its features when already enabled). Features must be a subset of the module\'s offered features.
     */
    async setCustomerModule(requestParameters: SetCustomerModuleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerModuleView> {
        const response = await this.setCustomerModuleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
